export const SEARCH_BAR_TOUR = 'tour';
export const SEARCH_BAR_BIKE_CLUB = 'club';
export const SEARCH_BAR_BIKER_BED = 'bikerbed';
export const SEARCH_BAR_PLACES = 'place';
export const SEARCH_BAR_MEMBER = 'member';
export const SEARCH_BAR_ALL = 'address';
export const SEARCH_BAR_HISTORY = 'history';
export const SEARCH_DEFAULT_ROAD_TYPE = '31';
